import { Link } from "react-router-dom";
import { FaHome, FaUsers, FaDatabase, FaPlusSquare } from "react-icons/fa";

const Sidebar = () => {
  return (
    <div className="bg-black text-white w-64 p-6 h-screen">
      <h2 className="text-2xl font-bold text-center mb-8">
        <span className="text-blue-400">EPIC</span> MOVIE
      </h2>
      
      <ul className="space-y-3">
        <li>
          <Link 
            to="/admin" 
            className="flex items-center space-x-3 text-lg p-3 rounded-md hover:bg-gray-800 transition-colors"
          >
            <FaHome className="text-blue-400" />
            <span>Inicio</span>
          </Link>
        </li>
        
        <li>
          <Link 
            to="/movies/new" 
            className="flex items-center space-x-3 text-lg p-3 rounded-md hover:bg-gray-800 transition-colors"
          >
            <FaPlusSquare className="text-blue-400" />
            <span>Agregar Película</span>
          </Link>
        </li>
        
        <li>
          <Link 
            to="/movies/list" 
            className="flex items-center space-x-3 text-lg p-3 rounded-md hover:bg-gray-800 transition-colors"
          >
            <FaDatabase className="text-blue-400" />
            <span>Lista de Películas</span>
          </Link>
        </li>
        
        <li>
          <Link 
            to="/clientes" 
            className="flex items-center space-x-3 text-lg p-3 rounded-md hover:bg-gray-800 transition-colors"
          >
            <FaUsers className="text-blue-400" />
            <span>Clientes</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;